export const getTeamName = (team) => {
  if (!team) {
    return '';
  }
  return (team.settings ? team.settings.name : team.name) || '';
};
